// Module Name
export const name = 'rides';

export const typeRides = {
    CREATE_RIDE: `${name}/CREATE_RIDE`,
    UPDATE_RIDE: `${name}/UPDATE_RIDE`,
    CANCEL_RIDE: `${name}/CANCEL_RIDE`,
    SOS_RIDE: `${name}/SOS_RIDE`,
    SOS_RIDE_CANCEL: `${name}/SOS_RIDE_CANCEL`,
    DELETE_RIDE: `${name}/DELETE_RIDE`,
    GET_RIDE: `${name}/GET_RIDE`,
    CHECK_SIMILAR_RIDE: `${name}/CHECK_SIMILAR_RIDE`,
    GET_RIDES: `${name}/GET_RIDES`,
    GET_SOON_RIDES: `${name}/GET_SOON_RIDES`,
    GET_TAGS: `${name}/GET_TAGS`,
    GET_CANCEL_REASONS: `${name}/GET_CANCEL_REASONS`,

    CREATE_RIDE_RECURRENT: `${name}/CREATE_RIDE_RECURRENT`,
    UPDATE_RIDE_RECURRENT: `${name}/UPDATE_RIDE_RECURRENT`,
    DELETE_RIDE_RECURRENT: `${name}/DELETE_RIDE_RECURRENT`,
    GET_RIDE_RECURRING: `${name}/GET_RIDE_RECURRING`,
    PAUSE_RIDE_RECURRING: `${name}/PAUSE_RIDE_RECURRING`,
    UPDATE_PAUSE_RIDE_RECURRING: `${name}/UPDATE_PAUSE_RIDE_RECURRING`,
    UN_PAUSE_RIDE_RECURRING: `${name}/UN_PAUSE_RIDE_RECURRING`,
};
